export default "__VITE_ASSET__DdgrrD9A__"